import { useT, Namespace } from "@racoon/i18n";
import { StatusPill } from "@racoon/ui";

/** «Активно» / «Отключено» badge of a job type, as in the design (100px, 8px radius). */
export const JobTypeStatusPill = ({ active }: { active: boolean }) => {
  const t = useT();
  return (
    <StatusPill
      radius="lg"
      className="w-[100px] border"
      tone={
        active
          ? "border-green-500 bg-green-100 text-green-600"
          : "border-slate-300 bg-slate-200 text-text-subtle"
      }
    >
      {t(Namespace.Settings, active ? "jobTypes.status.active" : "jobTypes.status.disabled")}
    </StatusPill>
  );
};
